import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UiModeService {
  // Single source of truth for the app version shown in both classic
  // and v2 UI. Bump this on every deploy.
  public readonly version = 'vSL-1.0.0_260825';

  // Outlets that ship the new UI only — no classic version, no way back to it.
  private readonly newUiOnlyShops = ['superlegend'];

  getMode(): string {
    return localStorage.getItem('uiMode') || 'classic';
  }

  setMode(mode: string) {
    // New-UI-only outlets must never be switched to classic, otherwise a stale
    // localStorage value would strand the customer on a UI that does not exist.
    if (this.isNewUiOnly()) {
      return;
    }
    localStorage.setItem('uiMode', mode);
  }

  isV2(): boolean {
    return this.isNewUiOnly() || this.getMode() === 'v2';
  }

  isNewUiOnly(shop?: string): boolean {
    return this.newUiOnlyShops.indexOf(shop || this.shopFromHost()) > -1;
  }

  shopFromHost(): string {
    const myUrl = window.location.origin;

    if (myUrl.indexOf('superlegend') > -1) {
      return 'superlegend';
    } else if (myUrl.indexOf('beihai') > -1) {
      return 'beihai';
    } else if (myUrl.indexOf('setapak') > -1) {
      return 'setapak';
    }
    return 'selayang';
  }

  // The app scrolls inside mat-sidenav-content (fullscreen sidenav layout),
  // so reset that container as well as the window.
  scrollToTop() {
    const content = document.querySelector('mat-sidenav-content');
    if (content) {
      content.scrollTop = 0;
    }
    window.scrollTo(0, 0);
  }

  titleFor(shop: string): string {
    if (shop === 'superlegend') {
      return '华鼎轩';
    } else if (shop === 'beihai') {
      return '北海海鲜酒家';
    } else if (shop === 'setapak') {
      return '强记海鲜酒家 (文良港)';
    }
    return '强记海鲜酒家 (士拉央)';
  }

  logoFor(shop: string): string {
    if (shop === 'superlegend') {
      return 'assets/brand/superlegend-logo.png';
    }
    return '';
  }
}
